import React from "react";
import "./Dpu_Learn_Ai_Tool_Swiper.css";
import Marquee from "react-fast-marquee";

const Dpu_Learn_Ai_Tool_Swiper = () => {
  const data = [
    "/assets/images/dpu_mca/ai_tools/1.webp",
    "/assets/images/dpu_mca/ai_tools/2.webp",
    "/assets/images/dpu_mca/ai_tools/3.webp",
    "/assets/images/dpu_mca/ai_tools/4.webp",
    "/assets/images/dpu_mca/ai_tools/6.webp",
    "/assets/images/dpu_mca/ai_tools/7.webp",
    "/assets/images/dpu_mca/ai_tools/8.webp",
    "/assets/images/dpu_mca/ai_tools/9.webp",
    "/assets/images/dpu_mca/ai_tools/10.webp",
    "/assets/images/dpu_mca/ai_tools/11.webp",
    "/assets/images/dpu_mca/ai_tools/13.webp",
    "/assets/images/dpu_mca/ai_tools/14.webp",
    "/assets/images/dpu_mca/ai_tools/15.webp",
    "/assets/images/dpu_mca/ai_tools/16.webp",
  ];

  return (
    <section className="Dpu_Learn_Ai_Tool_Swiper">
      <div className="container">
        <div className="text_heading_div text-center">
          <h2 className="text-black fs-3">Learn 25+ AI Tools</h2>
          <p className="text-center descn_text">
            Get hands-on experience in 25+ AI tools within a year and
            future-proof your career
          </p>
        </div>

        <div className="new_swiper_holder">
          <Marquee speed={50} gradient={false}>
            <div className="new_brands_holder">
              {data?.map((item, index) => (
                <div className="logo-div" key={index}>
                  <img
                    rel="preload"
                    loading="lazy"
                    className="uni-img"
                    src={item}
                  />
                </div>
              ))}
            </div>
          </Marquee>
        </div>
      </div>
    </section>
  );
};

export default Dpu_Learn_Ai_Tool_Swiper;
